import { AppSettings } from "../common/app.settings";

export class DashboardData{
    clientMeta:ClientMetaModel=new ClientMetaModel();
    stats:StatsModel[]=[];
    tenants:TenantModel[]=[];
}
export class ClientMetaModel{
    client:string;
    client_id:string;
    theme:string;
    theme_internal_name:string
    viewer_url:string;
    deserialize(input) {
        if(input){
        this.client=capitalize(input.client);
        this.client_id=input.client_id;
        this.theme=input.theme;
        this.theme_internal_name=input.theme;
        if(input.viewer_url && input.viewer_url!= '' && input.viewer_url != undefined)
            this.viewer_url=input.viewer_url;
        else
            this.viewer_url = AppSettings.URL_ENDPOINT;
        if(this.theme == '' || this.theme==undefined)
            this.theme="Global";
        if(this.theme =='theme2' || this.theme == 'Theme2') 
            this.theme='Top Menu - Blue';
        else if(this.theme =='sidemenu' || this.theme == 'Sidemenu') 
            this.theme='Side Menu - Blue';
        else if(this.theme =='classic' || this.theme == 'Classic')
            this.theme = "Classic Menu";
        else if(this.theme!="Global")
            this.theme = getThemeName(this.theme);
        }
    }
}
export class FormsData {
    formname: string;
    client_id:string;
    tenant_id:string;
    tenant:string
    env:string;
    updated_by:string;
    updated_date:string;
    published_by:string;
    published_date:string;
    active: string;
    published:string;
    actions: string;
    created_by:string;
    created_date:string
    deleted:string;
    pagecount:number
    template_id:string;
    unique_id:string;
    roles:string[];
    allRoles:string[][];
    signing_order:string[][];
    docusign:boolean;
    global:boolean;
    description:string;
    oldform:boolean
    deserialize(input) {
        if(input){
        this.client_id=capitalize(input.client_id);
        this.formname=capitalize(input.template_name);
        this.created_date=humanReadableDate(input.created_date);
        this.updated_date=humanReadableDate(input.updated_date);
        this.published_date=humanReadableDate(input.published_date);
        if(this.published_date=='' || this.published_date==undefined)
            this.published_date = 'N/A';
        this.published_by=input.published_by;
        this.created_by=input.created_by;
        this.updated_by=input.updated_by;
        this.deleted=booleantoYesNo(input.deleted);
        this.template_id=input.template_id;
        this.unique_id=input.unique_id;
        if(!this.unique_id)
            this.unique_id=this.formname;
        this.pagecount=input.pagecount;
        this.tenant_id=input.tenant_id;
        this.env=input.env;
        this.docusign=input.docusign;
        this.active=booleantoYesNo(!input.inactive);
        this.published=booleantoYesNo(input.published);
        this.roles = [];
        this.signing_order=[];
        if(input.roles)
        {
            this.roles=input.roles;
        }
        if(input.signing_order)
        {
            this.signing_order=input.signing_order;
        }
        }
    }
    deserializeGlobalForm(input) {
        if(input){
        this.client_id=capitalize(input.client_id);
        this.formname=capitalize(input.form_name);
        this.template_id=input.form_id;

        this.description=capitalize(input.description);
        this.created_date=humanReadableDate(input.created_date);
        this.updated_date=humanReadableDate(input.updated_date);
        this.published_date=humanReadableDate(input.published_date);
        this.published_by=input.published_by;
        this.created_by=input.created_by;
        this.updated_by=input.updated_by;
        this.deleted=booleantoYesNo(input.deleted);
        this.tenant_id=input.tenant_id;
        this.env=input.env;
        this.active=booleantoYesNo(!input.inactive);
        this.published=booleantoYesNo(input.published);
        this.global=input.global;
        this.oldform=input.oldform
        }
    }
  }
export class UsersModel{
    serial:number=0
    email:string;
    created_time:string;
    created_by:string;
    updated_time:string;
    updated_by:string;
    locked:boolean;
    active:string
    usertype:string;
    actions:string;
    verifed:string;
    tenants:TenantModel[]=[];
    expanded:boolean;

    deserialize(input) {
        if(input){
            this.expanded=false;

        this.serial=this.serial+1;
        this.email=lowercaseAll(input.email);
        this.created_by=lowercaseAll(input.created_by);
        this.created_time=humanReadableDate(input.created_time);
        this.updated_by=lowercaseAll(input.updated_by);
        this.updated_time=humanReadableDate(input.updated_time);
        this.locked=input.locked;
        this.active=booleantoYesNo(!input.locked);
        this.verifed=booleantoYesNo(!input.invited);
        }
    }
}
export class StatsModel{
    type:string;
    images:number;
    requests:number;
    forms:number;
    formTemplates:number;
    deserialize(input) {
        if(input){
        this.images=input.images;
        this.requests=input.requests;
        this.forms=input.forms;
        this.formTemplates=input.formtemplates;
        }
    }
}
export class VVOperationModel{
        theme: string;
        add:VVModel[]
        update:VVModel[]
}
export class VVModel{
    name:string;
    tenant:string;
    theme:string;
    env:string;
    timeout:number;
    created_time:string;
    created_by:string;
    updated_time:string;
    updated_by:string;
    active:string;
    inactive:boolean;
    s3_access_id:string;
	s3_secret_access_key:string;
    s3_region:string;
    s3_bucket_name:string;
    roles:string[];
    jsonRoles:string[];
    requested:boolean;
}
export class TenantModel extends VVModel {
    environments:any[]=[];
    actions:string;
    tenant:string;
    theme:string;
    expanded:boolean;
    totalenvironments:number
    deserialize(input) {
        if(input){
        this.expanded=false;
        this.name=capitalize(input.tenant);
        this.tenant=input.tenant;
        this.tenant=this.name;
        this.timeout=input.timeout;
        this.theme=input.theme;
        if(this.theme == '' || this.theme==undefined)
            this.theme="Global";
            if(this.theme =='theme2' || this.theme == 'Theme2') 
            this.theme='Top Menu - Blue';
        else if(this.theme =='sidemenu' || this.theme == 'Sidemenu') 
            this.theme='Side Menu - Blue';
        else if(this.theme =='classic' || this.theme == 'Classic')
            this.theme = "Classic Menu";
        else if(this.theme!="Global")
            this.theme = getThemeName(this.theme);
        this.created_by=lowercaseAll(input.created_by);
        this.created_time=humanReadableDate(input.created_time);
        this.updated_by=lowercaseAll(input.updated_by);
        this.active=booleantoYesNo(!input.inactive);
        this.inactive=input.inactive;
        this.updated_time=humanReadableDate(input.updated_time);
        this.s3_bucket_name=input.s3_bucket_name;
        let formattedRoles = [];
        this.roles = [];
        if(input.roles)
        {
            this.roles=input.roles;
            for (let r in input.roles){
                let role = {name:input.roles[r]};
                formattedRoles.push(role);
            }
        }
        if(input.envs)
        {
            this.environments=input.envs;
        }
        this.requested = input.requested;
        this.jsonRoles=formattedRoles;
        }
        this.totalenvironments=this.environments.length;
    }
}
export class EnvironmentDropDown{
    tenant:string;
    id:string;
    itemName:string;
}
export class EnvironmentModel extends VVModel {
    tenant:string;
    tenantenv:string
    deserialize(input,globaltheme) {
        if(input){
        this.tenant = input.tenant;
        this.tenantenv=input.tenant + "#" + input.env;
        this.name = capitalize(input.env);
        this.env=this.name;
        this.timeout=input.timeout;
        this.created_by=lowercaseAll(input.created_by);
        this.created_time=humanReadableDate(input.created_time);
        this.updated_by=lowercaseAll(input.updated_by);
        this.inactive=input.inactive;
        this.updated_time=humanReadableDate(input.updated_time);
        this.active=booleantoYesNo(!input.inactive);
        this.s3_bucket_name=input.s3_bucket_name;
        this.requested = input.requested;
        this.theme=input.theme;
        if(this.theme == '' || this.theme==undefined)
            this.theme=globaltheme;
        else{
            if(this.theme =='theme2' || this.theme == 'Theme2') 
            this.theme='Top Menu - Blue';
        else if(this.theme =='sidemenu' || this.theme == 'Sidemenu') 
            this.theme='Side Menu - Blue';
        else if(this.theme =='classic' || this.theme == 'Classic')
                this.theme = "Classic Menu";
            else if(this.theme!="Global")
                this.theme = getThemeName(this.theme);
        }
        }
    }
}
const capitalize = (s) => {
    if (typeof s !== 'string') return ''
    return s.charAt(0).toUpperCase() + s.slice(1)
  }
  const lowercaseAll = (s) => {
    if (typeof s !== 'string') return ''
    return s.toLocaleLowerCase();
  }
  /*const capitalcaseAll = (s) => {
    if (typeof s !== 'string') return ''
    return s.toLocaleUpperCase();
  }*/
const humanReadableDate = (s) => {
    if(s)
        return new Date(s).toLocaleDateString("en-US")
    else
    return "";
  }
  const booleantoYesNo = (s) => {
    if(s)
        return "Yes"
    else
    return "No";
  }
  const getThemeName = (name) =>{
    var splitted = name.split("-", 2); 
    var theme = splitted[0];
    if(theme =='theme2') 
            theme='Top Menu';
        else if(theme =='sidemenu') 
            theme='Side Menu';
        else if(theme =='classic')
            theme = "Classic Menu";
    return theme + " - " + capitalize(splitted[1]);
  }